export default {"src":"/_next/static/media/tanitimkagidi.d263926d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};